<script setup lang="ts">
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/ScrollTrigger';
    const props = defineProps<{ blok: TeaserStoryStoryblok }>();

    gsap.registerPlugin(ScrollTrigger);

    const hideNumbers = ref(props.blok.HideNumbers);
    const hideArrows = ref(props.blok.HideArrows);
    const storyLength = ref(props.blok.StoryStep?.length);
    const flipLayout = ref(props.blok.flipLayout);
    const theme = ref(props.blok.theme);

    const isReversed = (index: number) => {
        return index % 2 != 1;
    };

    const title = ref();

    onMounted(() => {
        gsap.from(title.value, {
            scrollTrigger: {
                trigger: title.value,
                scrub: 0.8,
                start: 'top bottom',
                end: 'bottom 50%',
                toggleActions: 'restart pause reverse pause'
            },
            y: 0,
            x: -50,
            opacity: 0
        });
    });
</script>

<template>
    <div
        v-editable="blok"
        class="story-wrapper"
    >
        <h2
            v-if="blok.StoryTitle"
            ref="title"
            class="story-title"
            :class="{ '--reverse': flipLayout }"
        >
            {{ blok.StoryTitle }}
        </h2>

        <div
            class="steps-wrapper"
            :class="{ '--no-arrows': hideArrows }"
        >
            <StoryblokComponentWrapper
                v-for="(item, index) in props.blok.StoryStep"
                :key="item._uid"
                :blok="item"
                :hide-numbers="hideNumbers"
                :hide-arrows="hideArrows"
                :theme="theme"
                :story-index="index + 1"
                :story-length="storyLength"
                :reverse="isReversed(flipLayout ? index + 2 : index + 1)"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/teaser/teaser-story.scss';
</style>
